import React, { FC } from 'react'
import { IPreventDoubleClickToZoomProps } from './types'
import style from './style.module.css';

const PreventDoubleClickToZoom: FC<IPreventDoubleClickToZoomProps> = ({ children }) => {
  return (
    <div className={style.root}>
      {children}
    </div>
  )
}

export default PreventDoubleClickToZoom
